import React from 'react';
import Navigation from './Navigation';
import './home.css'; 
import secure from '../src/standard-quality-control-collage-concept.jpg';
import file from '../src/file-management.jpg';
import pms from '../src/pms_management.jpg'
import cloud from '../src/cloud-business.jpg';
import storage from '../src/storage.jpg'
import policy from '../src/policy-control.jpg';

function Home() {
  return (
    <div>
      <Navigation />
      <div className="main-content">
        <div className="text-content">
          <h1>Project Management System</h1>
          <p>
          Our Project Management System (PMS) is designed to streamline your project and task management processes, providing you with the tools you need to stay organized, efficient, and productive. 
          </p>
          <p>
          With seamless integration with Microsoft Teams and a user-friendly interface, managing projects and tasks has never been easier.
          </p>
         
        </div>
        <div className="image-content">
          <img
            src={pms}
            alt="Image Alt Text"
          />
        </div>
      </div>
      <br/> <br/>
      {/* New Section */}
      
      <br/> <br/>
    {/* New section starts here */}
      <div className="main-content">
       
        <div className="image-content">
          <img
            src= {policy}
            alt="New Image Alt Text"
          />
        </div>
        <div className="text-content">
          <h1>Efficient Project Planning</h1>
          <p>
          Create, assign, and track tasks effortlessly with our task management features. Prioritize tasks, set due dates, and monitor progress with ease. Collaborate with team members, add comments, and attach files directly within tasks for seamless communication.
          </p>
          {/* <button className="discover-button">Manage with precision</button> */}
        </div>
      </div>
   
      <div className="main-content">
        <div className="text-content">
          <h1>Dashboard Overview</h1>
          <p>
          Our intuitive dashboard offers a comprehensive view of your projects, tasks, and team collaboration tools. Stay informed with real-time updates and notifications, ensuring you never miss an important deadline or task assignment.
          </p>
          {/* <button className="discover-button">Discover our pricing</button> */}
        </div>
        <div className="image-content">
          <img
            src={storage}
            alt="New Image Alt Text"
          />
        </div>
      </div>
     <div className="main-content sky-blue-background">
        <div className="text-content">
          <h1>
          Ready to elevate your project management with <br/>a secure and dependable solution tailored to your needs?</h1>
          {/* <button className="discover-button">SignUp</button> */}
        </div>
      </div>

      <section className="footer">
        <h4>Address</h4>
        <p>
          G-202, Maple Tree,
          Near Surdhara Circle, Thaltej,
          Ahmedabad-380052,India
        </p>

        <div className="icons">
          +91 760 000 2540<br />
          <div className="Policy">
            <a href="/privacy.html" style={{ color: 'black' }} target="_blank"><b>Privacy Policy</b></a> &nbsp;
            <a href="/term_conditions.html" style={{ color: 'black' }} target="_blank"><b>Terms of Use</b></a>
          </div>
          {/* <i className="fa-solid fa-envelope"></i>info@cloudservesystems.com<br/>
          <i className="fa-solid fa-envelope"></i>sales@cloudservesystems.com<br/>
          <i className="fa-solid fa-envelope"></i>support@cloudservesystems.com */}
        </div>
        <p>Copyright @2017 Cloudserve Systems Pvt. Ltd. All rights reserved. </p>
      </section>
    </div>
  );
}

export default Home;
